<template>
  <v-card flat tile style="background: transparent">
    <v-col cols="12" class="ma-0 pa-1">
      <!-- <v-row class="pa-0 ma-0" justify="center" align="center">
        <span class="body-regular-smaller">ENUNCIADOS</span>
        <v-spacer></v-spacer>
        <v-btn
          x-small
          icon
          @click="showingMenu.questions = !showingMenu.questions"
        >
          <v-icon v-if="showingMenu.questions">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-row> -->
      <template v-if="showingMenu.questions">
        <v-row style="line-height: 1">
          <v-col cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.pauseVideo')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7" class="d-flex align-center justify-end">
            <v-tooltip v-if="localQuestions.pauseVideoEnd" top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">
                  <v-switch
                    v-model="localQuestions.pauseVideo"
                    :disabled="localQuestions.pauseVideoEnd"
                    @change="emitPauseSwitch"
                    class="ma-0 pa-0 mt-1"
                    inset
                    dense
                    hide-details
                  ></v-switch>
                </div>
              </template>
              <span>{{ $t('message.quiz.onlyOnePause') }}</span>
            </v-tooltip>
            <v-switch
              v-else
              @change="emitPauseSwitch"
              v-model="localQuestions.pauseVideo"
              class="ma-0 pa-0 mt-1"
              inset
              dense
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row style="line-height: 1">
          <v-col cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.pauseEndVideo')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7" class="d-flex align-center justify-end">
            <v-tooltip v-if="localQuestions.pauseVideo" top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">
                  <v-switch
                    v-model="localQuestions.pauseVideoEnd"
                    :disabled="localQuestions.pauseVideo"
                    @change="emitEndPauseSwitch"
                    class="ma-0 pa-0 mt-1"
                    inset
                    dense
                    hide-details
                  ></v-switch>
                </div>
              </template>
              <span>{{ $t('message.quiz.onlyOnePause') }}</span>
            </v-tooltip>
            <v-switch
              v-else
              @change="emitEndPauseSwitch"
              v-model="localQuestions.pauseVideoEnd"
              class="ma-0 pa-0 mt-1"
              inset
              dense
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.allowSkip')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7" class="d-flex align-center justify-end">
            <v-switch
              @change="emitSkipSwitch"
              v-model="localQuestions.allowSkip"
              class="ma-0 pa-0 mt-1"
              inset
              dense
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5" class="mt-1">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.textBalonSkip')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7">
            <v-input
              @change="emitSkipText"
              @focus="isSkipInputFocused = true"
              @blur="isSkipInputFocused = false"
              style="font-size: 13px"
              v-model="localQuestions.skipButtonText"
              :rules="
                isSkipInputFocused ? [rules.required, rules.maxLength30] : []
              "
              counter="30"
              :placeholder="this.$t('message.pages.onboardingModal.skip')"
            ></v-input>
          </v-col>
        </v-row>
        <v-divider class="mt-6"></v-divider>
        <v-row class="pa-0 ma-0" justify="center" align="center">
          <span
            style="text-transform: uppercase"
            class="body-regular-smaller textType4--text"
            :class="{ 'pt-5': showingMenu.disposition }"
            >{{ $t('message.quiz.disposition') }}</span
          >
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="showingMenu.disposition = !showingMenu.disposition"
          >
            <v-icon v-if="showingMenu.disposition">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
        <template v-if="showingMenu.disposition">
          <v-row>
            <v-col class="d-flex align-center" cols="5">
              <span class="body-regular-small textType3--text">{{
                $t('message.quiz.disposition')
              }}</span
              ><br />
            </v-col>
            <v-col cols="7">
              <v-chip-group
                v-model="localQuestions.layout"
                @change="handleChangeLayout"
                mandatory
              >
                <v-chip class="chip-layout" :value="0" size="small">
                  {{ $t('message.quiz.horizontal') }}
                </v-chip>
                <v-chip class="chip-layout" :value="1" size="small">
                  {{ $t('message.quiz.vertical') }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <v-row v-if="localQuestions.layout === 0" class="mb-3">
            <v-col class="d-flex align-center" cols="5">
              <span class="body-regular-small textType3--text">{{
                $t('message.quiz.positionStatement')
              }}</span>
            </v-col>
            <v-col cols="7">
              <v-chip-group
                v-model="localQuestions.horizontalLayout"
                @change="handleChangeHorizontalLayout"
                mandatory
              >
                <v-chip class="chip-layout" :value="0" size="small">
                  {{ $t('message.quiz.topOfVideo') }}
                </v-chip>
                <v-chip class="chip-layout" :value="1" size="small">
                  {{ $t('message.quiz.nextOptions') }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <v-row v-if="localQuestions.layout === 1" class="mb-3">
            <v-col cols="5" class="d-flex align-center">
              <span class="body-regular-small textType3--text">{{
                $t('message.quiz.displaySide')
              }}</span>
            </v-col>
            <v-col cols="7">
              <v-chip-group
                v-model="localQuestions.verticalLayout"
                @change="handleChangeVerticalLayout"
                mandatory
              >
                <v-chip class="chip-layout" :value="0" size="small">
                  {{ $t('message.quiz.left') }}
                </v-chip>
                <v-chip class="chip-layout" :value="1" size="small">
                  {{ $t('message.quiz.right') }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </template>
      </template>
      <v-row class="pa-0 ma-0 border-top" justify="center" align="center">
        <span
          class="body-regular-smaller mb-7 textType4--text"
          :class="{ 'pt-5': showingMenu.animations }"
          >{{ $t('message.quiz.animations') }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          x-small
          icon
          @click="showingMenu.animations = !showingMenu.animations"
        >
          <v-icon v-if="showingMenu.animations">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-row>
      <template v-if="showingMenu.animations">
        <v-row>
          <v-col class="d-flex align-center" cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.startAnimations')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7">
            <v-select
              v-model="localQuestions.selectedEnterAnimation"
              @change="handleAnimationChange"
              :items="enterAnimations"
              outlined
              dense
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mb-5 d-flex align-center">
          <v-col cols="5" class="mt-1">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.endAnimations')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7">
            <v-select
              v-model="localQuestions.selectedExitAnimation"
              :items="exitAnimations"
              @change="handleAnimationChange"
              outlined
              dense
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>
      </template>
      <v-row class="pa-0 ma-0 border-top" justify="center" align="center">
        <span
          class="body-regular-smaller textType4--text"
          :class="{ 'pt-5': showingMenu.background }"
          >{{ $t('message.quiz.statements') }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          x-small
          icon
          @click="showingMenu.background = !showingMenu.background"
        >
          <v-icon v-if="showingMenu.background">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-row>
      <template v-if="showingMenu.background">
        <!-- <v-col class="quizWarning mb-6 mt-2">
          <v-icon color="#dfad2f" class="pr-3"> mdi-alert </v-icon>
          <span>Há perguntas sem enunciados. </span>
        </v-col> -->

        <v-row>
          <v-col class="d-flex align-center" cols="4">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.colorBackground')
            }}</span
            ><br />
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <v-row class="d-flex justify-end">
              <v-col
                class="pa-0 pr-3"
                v-for="(color, index) in backgroundColors"
                :key="index"
                cols="auto"
              >
                <div
                  class="background-color-box"
                  :style="{
                    border:
                      localBackground.color.color === color.background
                        ? '1.5px solid var(--Primary-800, #1D0092)'
                        : '1.5px solid var(--Gray-300, #D7DDE6)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }"
                  @click="selectStatementBackgroundColor(color)"
                >
                  <div
                    :style="{
                      backgroundColor: color.background,
                      width: '29px',
                      height: '29px',
                      borderRadius: '8px',
                      border: '1px solid var(--Base-White, #FFF)',
                    }"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center">
          <v-col cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.opacityBackground')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7">
            <v-slider
              v-model="localBackground.color.opacity"
              class="align-center"
              thumb-label
              :max="100"
              :min="0"
              hide-details
            >
              <template v-slot:append>
                <v-input
                  class="mt-1"
                  style="font-size: 13px; width: 62px"
                  v-model="opacityValue"
                  dense
                  outlined
                  hide-details
                  type="number"
                  suffix="%"
                  @keypress="preventInvalidOpacityInput($event, 'opacity')"
                  @paste="handlePaste($event, 'opacity')"
                  :max="100"
                  :min="0"
                ></v-input>
              </template>
            </v-slider>
          </v-col>
        </v-row>
        <v-row align="center" class="mb-4">
          <v-col cols="5">
            <span class="body-regular-small textType3--text">{{
              $t('message.pages.drm.drmApparence.colorText')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7" class="pr-2">
            <v-row align="center" class="d-flex justify-end pt-5 mr-1">
              <v-menu
                v-model="showingMenus.statementTextColorMenuOpen"
                offset-x
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :color="localQuestions.questionTextColor.color"
                    :style="
                      setColor(
                        showingMenus.statementTextColorMenuOpen,
                        localQuestions.questionTextColor.color
                      )
                    "
                    v-on="on"
                    icon
                    class="rounded-pill border-slate"
                  >
                    <span class="describeHexa">{{
                      localQuestions.questionTextColor.color
                    }}</span></v-btn
                  >
                </template>
                <v-color-picker
                  elevation="3"
                  v-model="localQuestions.questionTextColor.color"
                  flat
                  mode="hexa"
                  hide-mode-switch
                  :maxlength="7"
                  @input="emitQuestionTextColorChange"
                ></v-color-picker>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <!-- <v-row
        style="border-top: 1px solid var(--Gray-100, #e8ebf1)"
        class="pa-0 ma-0 mt-4"
        justify="center"
        align="center"
      >
        <span class="body-regular-smaller">ALTERNATIVAS</span>
        <v-spacer></v-spacer>
        <v-btn x-small icon @click="showingMenu.options = !showingMenu.options">
          <v-icon v-if="showingMenu.options">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-row>
      <template v-if="showingMenu.options">
        <v-row>
          <v-col cols="4">
            <span class="body-regular-small textType3--text">Disposição</span><br />
          </v-col>
          <v-col cols="7">
            <v-tabs
              class="tabSection"
              @change="handleChangeLayout"
              v-model="localQuestions.layout"
              background-color="transparent"
            >
              <v-tab
                class="dispositionTabs"
                :class="{ 'selected-tab': localQuestions.layout === 0 }"
                >Horizontal</v-tab
              >
              <v-tab
                class="dispositionTabs"
                :class="{ 'selected-tab': localQuestions.layout === 1 }"
                >Vertical</v-tab
              >
            </v-tabs>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" class="mt-6">
            <span class="body-regular-small textType3--text"
              >Posição das <br />
              alternativas</span
            >
          </v-col>
          <v-col class="d-flex justify-center" cols="7">
            <v-card flat height="128px" width="128px" class="background">
              <v-row no-gutters style="row-gap: 16px">
                <v-col
                  cols="4"
                  v-for="placement in buttonPlacements"
                  :key="placement.type"
                >
                  <v-btn
                    icon
                    :ripple="false"
                    class="no-shadow btn-position"
                    :class="
                      localQuestions.selectedButtonPlacement ===
                        placement.type && 'active'
                    "
                    @click="handleChangeButtonPlacement(placement.type)"
                  >
                    <simple-svg
                      :src="placement.icon"
                      fill-class-name="editStroke"
                      stroke-class-name="editStroke"
                      :stroke="
                        localQuestions.selectedButtonPlacement ===
                        placement.type
                          ? 'var(--v-primary-base)'
                          : 'var(--v-gray-500-base)'
                      "
                      width="24px"
                    />
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </template> -->
      <v-row class="pa-0 ma-0 border-top" justify="center" align="center">
        <span
          class="body-regular-smaller textType4--text"
          :class="{ 'pt-5': showingMenu.alternatives }"
          >{{ $t('message.quiz.ALTERNATIVES') }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          x-small
          icon
          @click="showingMenu.alternatives = !showingMenu.alternatives"
        >
          <v-icon v-if="showingMenu.alternatives">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-row>
      <template v-if="showingMenu.alternatives">
        <!-- <v-col class="quizWarning mb-6 mt-2">
          <v-icon color="#dfad2f" class="pr-3"> mdi-alert </v-icon>
          <span>Há perguntas sem alternativas. </span>
        </v-col> -->

        <span class="body-regular-small textType3--text">{{
          $t('message.quiz.buttonModel')
        }}</span>

        <v-row no-gutters class="mx-1 align-center">
          <v-col cols="4" class="d-flex align-center">
            <v-radio-group v-model="localQuestions.selectedButtonModel">
              <v-radio
                @change="emitSelectedButtonModel"
                value="default"
              ></v-radio>
            </v-radio-group>
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.standard')
            }}</span>
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <span
              :style="{
                backgroundColor: hovered
                  ? selectedColor.path
                  : selectedColor.fill,
                color:
                  '#FFF7AE' == selectedColor.fill.toUpperCase()
                    ? '#363940'
                    : '#A4BDFF' == selectedColor.fill.toUpperCase()
                    ? '#363940'
                    : '#fff',
              }"
              class="defaultButton"
              @mouseover="hovered = true"
              @mouseleave="hovered = false"
            >
              {{ $t('message.aboutCopyright') }}
            </span>
          </v-col>
        </v-row>

        <!-- Botão 3D -->
        <v-row no-gutters class="mx-1 align-center">
          <v-col cols="4" class="d-flex align-center">
            <v-radio-group v-model="localQuestions.selectedButtonModel">
              <v-radio
                @change="emitSelectedButtonModel"
                value="dimension"
              ></v-radio>
            </v-radio-group>
            <span class="body-regular-small textType3--text">3D</span>
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <span
              class="dimensionButton"
              :style="{
                backgroundColor: dimensionHovered
                  ? selectedColor.path
                  : selectedColor.fill,
                color:
                  '#FFF7AE' == selectedColor.fill.toUpperCase()
                    ? '#363940'
                    : '#A4BDFF' == selectedColor.fill.toUpperCase()
                    ? '#363940'
                    : '#fff',
              }"
              @mouseover="dimensionHovered = true"
              @mouseleave="dimensionHovered = false"
            >
              {{ $t('message.aboutCopyright') }}
            </span>
          </v-col>
        </v-row>

        <!-- Botão Losangular -->
        <v-row no-gutters class="mx-1 align-center">
          <v-col cols="4" class="d-flex align-center">
            <v-radio-group v-model="localQuestions.selectedButtonModel">
              <v-radio
                @change="emitSelectedButtonModel"
                value="losangle"
              ></v-radio>
            </v-radio-group>
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.rhombus')
            }}</span>
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <span
              class="losangleButton"
              @mouseenter="losangleHovered = true"
              @mouseleave="losangleHovered = false"
            >
              {{ $t('message.aboutCopyright') }}
              <br />
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="153"
                  height="5"
                  viewBox="0 0 153 5"
                  fill="none"
                >
                  <path
                    d="M153 2.5L76.5 0.5L0 2.5L76.5 4.5L153 2.5Z"
                    fill="url(#paint0_linear_6400_33798)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_6400_33798"
                      x1="0"
                      y1="0"
                      x2="153"
                      y2="0"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        offset="-0.0012"
                        :stop-color="
                          losangleHovered
                            ? selectedColor.path
                            : selectedColor.fill
                        "
                      />
                      <stop
                        offset="0.9988"
                        :stop-color="
                          losangleHovered
                            ? selectedColor.path
                            : selectedColor.fill
                        "
                      />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </span>
          </v-col>
        </v-row>

        <!-- Botão Contorno -->
        <v-row no-gutters class="mx-1 align-center">
          <v-col cols="4" class="d-flex align-center">
            <v-radio-group v-model="localQuestions.selectedButtonModel">
              <v-radio
                @change="emitSelectedButtonModel"
                value="contour"
              ></v-radio>
            </v-radio-group>
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.contour')
            }}</span>
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <span
              :style="
                'border: 2px solid' +
                (contourHovered ? selectedColor.path : selectedColor.fill)
              "
              class="countourButton"
              @mouseenter="contourHovered = true"
              @mouseleave="contourHovered = false"
            >
              {{ $t('message.aboutCopyright') }}
            </span>
          </v-col>
        </v-row>

        <v-row class="pt-4">
          <v-col class="d-flex align-center" cols="4">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.buttonColor')
            }}</span
            ><br />
          </v-col>
          <v-col cols="8" class="d-flex align-center">
            <v-row class="d-flex justify-end">
              <v-col
                class="pa-0 pr-3"
                v-for="(color, index) in colors"
                :key="index"
                cols="auto"
              >
                <div
                  class="color-box"
                  :style="{
                    border:
                      selectedColor === color
                        ? '1.5px solid var(--Primary-800, #1D0092)'
                        : '1.5px solid var(--Gray-300, #d7dde6)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }"
                  @click="selectColor(color)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <g clip-path="url(#clip0)">
                      <rect width="32" height="32" rx="8" :fill="color.fill" />
                      <path d="M0 32L32 0V32H0Z" :fill="color.path" />
                    </g>
                    <rect
                      x="0.5"
                      y="0.5"
                      width="31"
                      height="31"
                      rx="7.5"
                      stroke="white"
                    />
                    <defs>
                      <clipPath id="clip0">
                        <rect width="32" height="32" rx="8" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="pt-4">
          <v-col class="d-flex align-center" cols="4">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.colorBackground')
            }}</span
            ><br />
          </v-col>
          <v-col cols="8" class="d-flex justify-end align-center">
            <v-row class="d-flex justify-end">
              <v-col
                class="pa-0 pr-3"
                v-for="(color, index) in backgroundColors"
                :key="index"
                cols="auto"
              >
                <div
                  class="background-color-box"
                  :style="{
                    border:
                      localQuestions.alternativesSelectedBackgroundColor ===
                      color
                        ? '1.5px solid var(--Primary-800, #1D0092)'
                        : '1.5px solid var(--Gray-300, #D7DDE6)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }"
                  @click="selectBackgroundColor(color)"
                >
                  <div
                    :style="{
                      backgroundColor: color.background,
                      width: '29px',
                      height: '29px',
                      borderRadius: '8px',
                      border: '1px solid var(--Base-White, #FFF)',
                    }"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="d-flex align-center pt-1 mb-2">
          <v-col cols="5" class="mb-1">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.opacityBackground')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7">
            <v-slider
              v-model="localBackground.color.alternativesOpacity"
              class="align-center mb-1"
              thumb-label
              :max="100"
              :min="0"
              hide-details
            >
              <template v-slot:append>
                <v-input
                  style="font-size: 13px; width: 62px"
                  v-model="alternativesOpacityValue"
                  class="mt-1"
                  dense
                  outlined
                  hide-details
                  type="number"
                  suffix="%"
                  @keypress="
                    preventInvalidOpacityInput($event, 'alternativesOpacity')
                  "
                  @paste="handlePaste($event, 'alternativesOpacity')"
                  :max="100"
                  :min="0"
                ></v-input>
              </template>
            </v-slider>
          </v-col>
        </v-row>
      </template>

      <v-row class="pa-0 ma-0 pt-5 border-top" justify="center" align="center">
        <span class="body-regular-smaller textType4--text">{{
          $t('message.quiz.timeBar')
        }}</span>
        <v-spacer></v-spacer>
        <v-tooltip v-if="localQuestions.pauseVideo" top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-switch
                v-model="hasTimeBar"
                :disabled="localQuestions.pauseVideo"
                @change="emitHasTimeBar"
                class="ma-0 pa-0 mt-1"
                inset
                dense
                hide-details
              ></v-switch>
            </div>
          </template>
          <span>{{ $t('message.quiz.notPossibleActivateOption') }}</span>
        </v-tooltip>
        <v-switch
          v-else
          v-model="hasTimeBar"
          @change="emitHasTimeBar"
          class="ma-0 pa-0 mt-1"
          inset
          dense
          hide-details
        ></v-switch>
      </v-row>
      <template v-if="hasTimeBar">
        <v-row class="mb-2">
          <v-col cols="5" class="ma-0 pt-5">
            <span class="body-regular-small textType3--text">{{
              $t('message.quiz.barColor')
            }}</span
            ><br />
          </v-col>
          <v-col cols="7" class="py-0 ma-0">
            <v-row align="center" class="ma-0 mt-6 justify-end">
              <span class="mr-2 label-text">{{
                localQuestions.fontColor.color
              }}</span>
              <v-menu
                v-model="showingMenu.fontColorMenuOpen"
                offset-x
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :color="localQuestions.fontColor.color"
                    style="
                      height: 16px !important;
                      width: 16px;
                      border-radius: 8px;
                      border: 1px solid #000;
                    "
                    :style="`transition: border-radius 200ms ease-in-out;background: ${localQuestions.fontColor.color};`"
                    v-on="on"
                    icon
                  ></v-btn>
                </template>
                <v-color-picker
                  v-model="localQuestions.fontColor.color"
                  flat
                  mode="hexa"
                  hide-mode-switch
                  :maxlength="7"
                ></v-color-picker>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'GeneralConfigs',
  props: {
    questions: {
      type: Object,
      required: true,
    },
    background: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
    }),
    rules() {
      return {
        required: (v) => (v && !!v) || this.$t('message.requiredFill'),
        maxLength30: (v) =>
          (v && v.length <= 30) || this.$t('message.maximumLengthQuiz30'),
      }
    },
    opacityValue: {
      get() {
        return this.localBackground.color.opacity
      },
      set(value) {
        const stringValue = value
          .toString()
          .replace(/[^0-9]/g, '')
          .substring(0, 3)
        const numValue = parseInt(stringValue) || 0
        const clampedValue = Math.max(0, Math.min(100, numValue))
        this.localBackground.color.opacity = clampedValue
      },
    },
    alternativesOpacityValue: {
      get() {
        return this.localBackground.color.alternativesOpacity
      },
      set(value) {
        const stringValue = value
          .toString()
          .replace(/[^0-9]/g, '')
          .substring(0, 3)
        const numValue = parseInt(stringValue) || 0
        const clampedValue = Math.max(0, Math.min(100, numValue))
        this.localBackground.color.alternativesOpacity = clampedValue
      },
    },
  },
  data() {
    return {
      hovered: false,
      contourHovered: false,
      dimensionHovered: false,
      losangleHovered: false,
      localCtaDuration: 0,
      hasTimeBar: false,
      enterAnimations: [],
      exitAnimations: [],
      colors: [
        { fill: '#8B0A06', path: '#9D2F2B' },
        { fill: '#FFF7AE', path: '#FFFBDC' },
        { fill: '#BE8B06', path: '#C89C2C' },
        { fill: '#3A9020', path: '#58A141' },
        { fill: '#1D0092', path: '#3F26A2' },
        { fill: '#A4BDFF', path: '#E4ECFF' },
        { fill: '#3F55EE', path: '#0F22A1' },
      ],
      selectedColor: { fill: '#3F55EE', path: '#EBEEFF' },
      backgroundColors: [
        { background: '#FFFFFF' }, // Cor branca
        { background: '#000000' }, // Cor preta
      ],
      localQuestions: {
        alternativesSelectedBackgroundColor: { background: '#000000' },
        selectedEnterAnimation: 'nothing',
        selectedExitAnimation: 'nothing',
        layout: 0,
        horizontalLayout: 0,
        verticalLayout: 0,
        styleText: '',
        selectedButtonModel: 'default',
        allowSkip: true,
        pauseVideo: true,
        pauseVideoEnd: true,
        skipButtonText: this.$t('message.pages.onboardingModal.skip'),
        formatOptions: ['Vertical', 'Horizontal'],
        fontSize: 16,
        fontColor: {
          color: '#000000',
        },
        questionTextColor: {
          color: '#FFFFFF',
        },
        fontWeight: 'normal',
        availableFontWeights: [
          { name: 'Normal', value: 'normal' },
          { name: 'Bold', value: 'bold' },
          { name: 'Bolder', value: 'bolder' },
          { name: 'Lighter', value: 'lighter' },
        ],
      },
      localBackground: {
        color: {
          color: '#000000',
          opacity: 100,
          alternativesOpacity: 100,
        },
      },
      showingMenu: {
        background: true,
        animations: true,
        timeBar: true,
        alternatives: true,
        questions: true,
        disposition: true,
        options: false,
        fontColorMenuOpen: false,
      },
      showingMenus: {
        statementTextColorMenuOpen: false,
      },
      isSkipInputFocused: false,
    }
  },
  mounted() {
    this.$root.$on('changeLanguage', this.updateText)
    this.$nextTick(() => {
      if (!this.localQuestions.selectedEnterAnimation) {
        this.localQuestions.selectedEnterAnimation = 'nothing'
      }
      if (!this.localQuestions.selectedExitAnimation) {
        this.localQuestions.selectedExitAnimation = 'nothing'
      }
      this.localQuestions.fontColor.color = '#5F2EEA'
      this.localQuestions.questionTextColor.color = '#FFFFFF'

      this.localQuestions.selectedButtonModel = 'default'
      this.emitSelectedButtonModel()
      this.selectedColor = this.colors[this.colors.length - 1]
      this.selectColor(this.selectedColor)
      this.localQuestions.alternativesSelectedBackgroundColor.background =
        '#000000'
      const currentCta = this.video?.config?.ctas?.find(
        (cta) => cta?.metadata?.generalData?.id === this.$route.params.quizId
      )
      if (currentCta) {
        const ctaDuration = currentCta.duration || 0
        this.localCtaDuration = ctaDuration || 0
        this.selectedColor = currentCta.buttonColor || this.selectedColor
        this.localQuestions.alternativesSelectedBackgroundColor =
          currentCta?.alternativesSelectedBackgroundColor || '#000000'
        this.localQuestions.selectedButtonModel =
          currentCta?.selectedButtonModel || 'default'
        this.hasTimeBar = currentCta.hasTimeBar || false
        this.localQuestions.fontColor.color = currentCta.barColor || '#5F2EEA'
        this.localQuestions.questionTextColor.color =
          currentCta?.metadata?.generalData?.questions?.questionTextColor
            ?.color || this.localQuestions.questionTextColor.color
        this.emitHasTimeBar()
        this.handleChangeHorizontalLayout()
        this.handleChangeVerticalLayout()
        this.handleChangeLayout()
        this.emitSelectedButtonModel()
        this.selectColor(currentCta.buttonColor)
        this.handleChangeAlternativesSelectedBackgroundColor()
      }

      this.$forceUpdate()
    })
    ;(this.enterAnimations = [
      {
        text: this.$i18next.t('message.nothing'),
        value: 'nothing',
      },
      {
        text: this.$i18next.t('message.verticalEntry'),
        value: 'vertical_entry',
      },
      {
        text: this.$i18next.t('message.horizontalEntry'),
        value: 'horizontal_entry',
      },
    ]),
      (this.exitAnimations = [
        { text: this.$i18next.t('message.nothing'), value: 'nothing' },
        {
          text: this.$i18next.t('message.verticalExit'),
          value: 'vertical_exit',
        },
        {
          text: this.$i18next.t('message.horizontalExit'),
          value: 'horizontal_exit',
        },
      ])
  },
  beforeDestroy() {
    this.$root.$off('changeLanguage')
  },
  watch: {
    questions: {
      immediate: true,
      handler(newValue) {
        this.localQuestions = { ...newValue }

        if (!this.localQuestions.selectedEnterAnimation) {
          this.$set(this.localQuestions, 'selectedEnterAnimation', 'nothing')
        }
        if (!this.localQuestions.selectedExitAnimation) {
          this.$set(this.localQuestions, 'selectedExitAnimation', 'nothing')
        }

        if (!this.localQuestions.questionTextColor) {
          this.$set(this.localQuestions, 'questionTextColor', {
            color: '#FFFFFF',
          })
        }

        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
    },
    localQuestions: {
      deep: true,
      handler(newValue) {
        this.$emit('update:questions', newValue)
      },
    },
    background: {
      immediate: true,
      handler(newValue) {
        this.localBackground = { ...newValue }
      },
    },
    locale: {
      handler() {
        this.updateText()
      },
      immediate: true,
    },
    localBackground: {
      deep: true,
      handler(newValue) {
        this.$emit('update:background', newValue)
      },
    },
    'localQuestions.pauseVideo': function (newValue) {
      if (newValue) {
        this.hasTimeBar = false
        this.emitHasTimeBar()
      }
    },
  },
  methods: {
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_LOADING_SAVE']),
    handleChangeLayout() {
      if (this.localQuestions.layout === 0) {
        this.localQuestions.verticalLayout = null
        this.$root.$emit(
          'update:verticalLayout',
          this.localQuestions.verticalLayout
        )
      } else {
        this.localQuestions.horizontalLayout = null
        this.$root.$emit(
          'update:horizontalLayout',
          this.localQuestions.horizontalLayout
        )
      }
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:layout', this.localQuestions.layout)
    },
    updateText() {
      this.enterAnimations = [
        { text: this.$i18next.t('message.nothing'), value: 'nothing' },
        {
          text: this.$i18next.t('message.verticalEntry'),
          value: 'vertical_entry',
        },
        {
          text: this.$i18next.t('message.horizontalEntry'),
          value: 'horizontal_entry',
        },
      ]
      this.exitAnimations = [
        { text: this.$i18next.t('message.nothing'), value: 'nothing' },
        {
          text: this.$i18next.t('message.verticalExit'),
          value: 'vertical_exit',
        },
        {
          text: this.$i18next.t('message.horizontalExit'),
          value: 'horizontal_exit',
        },
      ]
    },

    handleChangeHorizontalLayout() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:horizontalLayout',
        this.localQuestions.horizontalLayout
      )
    },

    handleChangeVerticalLayout() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:verticalLayout',
        this.localQuestions.verticalLayout
      )
    },

    emitHasTimeBar() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:hasTimeBar', this.hasTimeBar)
    },

    handleAnimationChange() {
      this.$forceUpdate()
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:enterAnimation',
        this.localQuestions.selectedEnterAnimation
      )
      this.$root.$emit(
        'update:exitAnimation',
        this.localQuestions.selectedExitAnimation
      )
    },

    handleChangeAlternativesSelectedBackgroundColor() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:alternativesSelectedBackgroundColor',
        this.localQuestions.alternativesSelectedBackgroundColor
      )
    },
    selectColor(color) {
      this.selectedColor = color
      this.emitSelectedColor()
    },

    setColor(menuOpen, color) {
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menuOpen ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },

    emitFontColorChange() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:fontColor', this.localQuestions.fontColor)
    },

    emitQuestionTextColorChange() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:questionTextColor',
        this.localQuestions.questionTextColor
      )
    },

    emitSelectedColor() {
      this.$nextTick(() => {
        this.localBackground.color.opacity =
          this.localBackground.color.opacity + 0.001
        this.$root.$emit('update:selectedColor', this.selectedColor)
      })
    },

    selectBackgroundColor(color) {
      this.localQuestions.alternativesSelectedBackgroundColor = color
      this.handleChangeAlternativesSelectedBackgroundColor()
    },

    preventInvalidOpacityInput(event, field) {
      const currentValue =
        field === 'opacity'
          ? this.localBackground.color.opacity
          : this.localBackground.color.alternativesOpacity

      const key = event.key
      const currentValueStr = currentValue.toString()

      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          'Backspace',
          'Delete',
          'Tab',
          'Enter',
          'ArrowLeft',
          'ArrowRight',
          'ArrowUp',
          'ArrowDown',
        ].includes(key)
      ) {
        return
      }

      if (!/[0-9]/.test(key)) {
        event.preventDefault()
        return
      }

      const input = event.target
      const selectionStart = input.selectionStart || 0
      const selectionEnd = input.selectionEnd || 0

      const newValue =
        currentValueStr.substring(0, selectionStart) +
        key +
        currentValueStr.substring(selectionEnd)

      if (newValue.length > 3) {
        event.preventDefault()
        return
      }

      const numericValue = parseInt(newValue) || 0
      if (numericValue > 100) {
        event.preventDefault()
      }
    },

    handlePaste(event, field) {
      event.preventDefault()
      const paste = (event.clipboardData || window.clipboardData).getData(
        'text'
      )

      const cleanPaste = paste.replace(/[^0-9]/g, '').substring(0, 3)
      const numericValue = parseInt(cleanPaste) || 0
      const clampedValue = Math.max(0, Math.min(100, numericValue))

      if (field === 'opacity') {
        this.localBackground.color.opacity = clampedValue
      } else if (field === 'alternativesOpacity') {
        this.localBackground.color.alternativesOpacity = clampedValue
      }
    },

    selectStatementBackgroundColor(color) {
      this.localBackground.color.color = color.background
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$emit('update:background', this.localBackground)
    },

    emitSkipText() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:skipText', this.localQuestions.skipButtonText)
    },

    emitPauseSwitch() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:pauseVideo', this.localQuestions.pauseVideo)
    },

    emitEndPauseSwitch() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit(
        'update:pauseVideoEnd',
        this.localQuestions.pauseVideoEnd
      )
    },

    emitSelectedButtonModel() {
      this.$nextTick(() => {
        this.localBackground.color.opacity =
          this.localBackground.color.opacity + 0.001
        this.$root.$emit(
          'update:selectedButtonModel',
          this.localQuestions.selectedButtonModel
        )
      })
    },

    emitSkipSwitch() {
      this.localBackground.color.opacity =
        this.localBackground.color.opacity + 0.001
      this.$root.$emit('update:allowSkip', this.localQuestions.allowSkip)
    },
  },
}
</script>

<style scoped lang="scss">
.border-top {
  border-top: 1px solid varFigma(neutral-95-lightest);
}

.border-slate {
  height: 16px !important;
  width: 17px !important;
  border: varFigma(neutral-30-base) 1px solid;
}

.describeHexa {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 10%;
  color: varFigma(neutral-40-light);
  margin-right: 130px;
  width: 100px;
  display: flex;
  justify-content: end;
}

.btn-position {
  border: 1px solid var(--v-gray-600-base);
  background: var(--v-gray-100-base);
  padding: 4px;
  border-radius: 8px;
  height: unset !important;
  width: unset;

  &.active {
    background: #e4ecff;
    border-color: var(--v-primary-base);
  }
}

.color-circle {
  width: 16px;
  height: 16px;
  border: 1px solid var(--Gray-200, #e8ebf1);
  margin-right: 8px;
  border-radius: 200px;
}

.color-selector {
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid var(--Gray-200, #e8ebf1);
  background: #fff;
  display: flex;
  padding: 12px 13px;
  max-height: 42px;
  align-items: flex-start;
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 14.4px */
  letter-spacing: -0.06px;
}

.defaultButton {
  display: flex;
  padding: 14px var(--Box-Margem-vertical, 24px);
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.losangleButton {
  color: var(--Base-Black, #363940);
  text-align: center;
  height: 40px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
  line-height: normal;
}

.dimensionButton {
  display: flex;
  padding: 14px var(--Box-Margem-vertical, 24px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #fff;
  text-align: center;
  height: 40px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  align-self: stretch;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.25) inset,
    -4px -4px 8px 0px rgba(255, 255, 255, 0.25) inset;
}

.countourButton {
  display: flex;
  padding: 4px var(--Box-Margem-vertical, 24px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  color: var(--Base-Black, #363940);
  height: 40px;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.color-box {
  width: var(--Box-Margem-horizontal, 32px);
  height: var(--Box-Margem-horizontal, 32px);
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .chip-layout {
  height: 32px !important;
  padding: 4px 16px !important;
  width: 100px !important;
  justify-content: center !important;
}

.bg-dark .countourButton {
  color: #e3e4e8;
}

.bg-dark .losangleButton {
  color: #e3e4e8;
}

.label-text {
  color: varFigma(neutral-40-light);
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
